<template>
    <div class="direct-container" v-loading="loadingFull||!textList">
        <div v-if="noData =='false'">
              <div class="container">
            <!-- 头部 -->
            <activityHeader :textList='textList' :textObj='textObj' :statusText="statusTextObj[$route.query.status]" type="1"/>
            <div class="direct-content">
                <!-- <div v-if="$route.query.status == 0" style="color:#FF5959">当前活动暂未开始</div> -->
                <div v-if="$route.query.status != 0" class="content-qrcode">
                    <div v-if="$route.query.status == 1">
                        <div
                                v-if="directActivityDetails.signature == ''"
                                class="qrcode"
                                style="width:290px;height:290px;display: inline-block;"
                        >
                            <img :src="qrcodeImg" alt />
                        </div>

                        <div v-if="directActivityDetails.signature == ''">
                            <div class="qrcode">我的打卡二维码</div>
                            <div class="refresh" @click="refreshQrcode">点击刷新二维码</div>
                        </div>
                    </div>
                    <!-- <div v-else>该活动已经结束</div> -->
                </div>
                <div v-if="$route.query.status != 0" class="content-clockin">
                    <div
                            class="clock"
                            v-for="(item,index) in directActivityDetails.punchCard"
                            :key="item.punchCardId"
                            @click="clockIn(item)"
                    >
                        <div class="clock-list">
                            <div class="list-hint">
                                <span :class="[item.punchTime == '未打'? 'unrecord':'record']"></span>
                            </div>
                            <div :class="[item.punchTime == '未打'? 'unrecord':'record','list-record']">
                                <div class="date">{{item.punchTime}}</div>
                                <div class="position" style="flex:8">打卡点{{index + 1}}：{{item.punchCardName}}</div>
                                <!-- <el-button
                                  class="ibeacon-btn"
                                  v-if="item.bottem&&item.punchTime=='未打'"
                                  @click="punchTheClock(item)"
                                  style="margin-left:5rem;bottem:3rem"
                                  round
                                >确认打卡</el-button> -->
                            </div>
                            <div style="flex:3;display:flex;align-items:center" >
                                <wx-open-launch-weapp style="width: 94%;height: 94%;margin-left:5px;margin-bottom:2px;"
                                        v-if="item.punchTime == '未打'"
                                        id="launch-btn"
                                        username="gh_3e12937b4dbc"
                                        :path="getPath(item)">
                                    <script type="text/wxtag-template">
                                        <!-- <div style="width:100%;height:100%;display: flex;flex-direction: column;justify-content: center;align-items: center;margin-left:10px;">
                                            <img style="width: 28px;height: 28px" width="28px" height="28px" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAADBElEQVR4Xu1bvWsUURD/zeZEsBA7rUTwHzCV6XLv9G4/DBoF0c5oZUrFCFZqI0KKCIJaClYS1BiT27tdvZdUUfAvEAQRGzuxEb92ZNW93JeQ3H54l53tdtn5zexv3r43b+YNIecX5fz78U8CJrXe9RXfioAxDvCBzRBlGHR7ebz8eDMyvd519PKeAIUpApn9YDFjDaBV2vF9zR1zPvfC6EmApb0pAq4C2NeP4lCGiS/XiuZsv/KhnK09DaAYB+Ov7EeAH7jKnOnE6iLA1h4noDCEWHFVRfWLZWm3SBgJCUj0clWl7ZvbbmxdnwXoUhIaOeDrtUPmtThYtvafADwZB6NTloGzNVW5Hz1vEmC/rO7El8IbALtjK2S+O/LTuLlULr+Pg2Xp+mnAOENgKw5Oh+y77dg2uqDUp/B5kwCr4ZtEXGt9OfSiYYy8rqrDSwkakBmU06gfDBg2GRTOZy0XH3eVudBBgHeDCFdaXyPmsWrJfJWZxSkocvTzCUbwrB2abrmqfKGNgF4zbueEkYJ9mUD2mNibE/T6HNBjyRECOpaMTNyVghIZAd2xjfwCUZAmc0D0y8kqIKtA985LlkFZBtu3jiks0ZlAShywkTjgyKp/Igj4UXOfzDxXLZkXM3FRykrsRv0OiKYjNcw4VitVFts2Q+GNtVKfISaHiRaJC/OuUh9Sti0T+Anf3/vDCM6RQeMEPKyqyr2mozOxYICVSFp8gJ2TiWkyAjKheYCVyAiInOPoWpKp5wH2+R/Tqsr6nQEn2/dHUcA8wPsH3upEDaS3MHCS7BXvBRilRLGHBYzQEAJy/wvkfhIclt81LTslDkiL2WHBlREwLJ5Ky04ZAa3MOto7z8CpXKbErIZ3lAhPm7myvCVFpTYotUGpDXYdS5XiqBRHpTi6JQIlqQ5vpDoscYDEARIH5DsOsBo5Py6f+4aJ3LfMhHmAXDdNRYmQXLfNRSQk0ThJwHTraax+kpr/pXEyMjRO6ywz5qJzeP18+Hq57j+1zsYxethkt8RuLw7pvwAZIQZLuWvOFwAAAABJRU5ErkJggg=="/>
                                            <div style="color:#29BEBC;font-size:14px;margin-top:10px">扫码</div>
                                        </div> -->
                                         <img  width="100%" height="100%" style="width: 100%;height:100%;margin-bottom:2px;" src="data:image/png;base64,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" />
                                    </script>
                                </wx-open-launch-weapp>
                                <div  v-else class="punch_text">
                                    <img src="../../assets/images/singIn.png" style="width: 100%;height: 100%;opacity:0.34;" />
                                    <!-- <svg t="1597737089731" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2966" width="28" height="28"><path d="M986.606857 548.505425 37.393143 548.505425c-20.156062 0-36.511565-16.35448-36.511565-36.505425 0-20.155039 16.355503-36.510542 36.511565-36.510542l949.213713 0c20.188808 0 36.511565 16.35448 36.511565 36.510542C1023.117398 532.149922 1006.794641 548.505425 986.606857 548.505425L986.606857 548.505425z" p-id="2967" fill="#49BFBA"></path><path d="M877.080348 986.610438 658.033469 986.610438c-20.188808 0-36.511565-16.320711-36.511565-36.510542 0-20.188808 16.321734-36.511565 36.511565-36.511565l219.047902 0c20.154016 0 36.510542-16.355503 36.510542-36.505425L913.591913 694.542476c0-20.188808 16.316617-36.511565 36.511565-36.511565 20.188808 0 36.505425 16.322757 36.505425 36.511565l0 182.542476C986.606857 937.465135 937.46667 986.610438 877.080348 986.610438L877.080348 986.610438z" p-id="2968" fill="#49BFBA"></path><path d="M329.453942 986.610438 146.911466 986.610438c-60.379159 0-109.519346-49.143257-109.519346-109.525486L37.39212 694.542476c0-20.188808 16.35448-36.511565 36.504402-36.511565 20.155039 0 36.510542 16.322757 36.510542 36.511565l0 182.542476c0 20.147876 16.389272 36.505425 36.504402 36.505425L329.453942 913.590378c20.155039 0 36.512588 16.322757 36.512588 36.511565C365.965507 970.289728 349.608981 986.610438 329.453942 986.610438L329.453942 986.610438z" p-id="2969" fill="#49BFBA"></path><path d="M73.896522 365.961926c-20.149922 0-36.504402-16.353456-36.504402-36.503379L37.39212 146.916071c0-60.386322 49.140187-109.526509 109.519346-109.526509L329.453942 37.389562c20.155039 0 36.512588 16.355503 36.512588 36.510542 0 20.147876-16.355503 36.504402-36.512588 36.504402L146.911466 110.404506c-20.11513 0-36.504402 16.393365-36.504402 36.510542l0 182.542476C110.408087 349.607446 94.051561 365.961926 73.896522 365.961926L73.896522 365.961926z" p-id="2970" fill="#49BFBA"></path><path d="M950.101431 365.961926c-20.192901 0-36.511565-16.353456-36.511565-36.503379L913.589866 146.916071c0-20.117177-16.35448-36.510542-36.510542-36.510542L658.033469 110.405529c-20.188808 0-36.511565-16.356526-36.511565-36.504402 0-20.155039 16.321734-36.510542 36.511565-36.510542l219.047902 0c60.386322 0 109.525486 49.140187 109.525486 109.526509l0 182.542476C986.606857 349.607446 970.289216 365.961926 950.101431 365.961926L950.101431 365.961926z" p-id="2971" fill="#49BFBA"></path></svg>
                                    <div>扫码</div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="$route.query.status != 0" class="sign-footer">
            <div class="sign">
                <div class="sign-input">
                    <img
                            class="img"
                            v-if="directActivityDetails.signature"
                            :src="directActivityDetails.signature"
                            alt
                            srcset
                    />
                </div>
                <div :class="[state == 1 ? 'save-btn':'save-btn-disabled']" @click="showPopup('myPopup')">
                    <p>{{btnText}}</p>
                </div>
            </div>
        </div>
        <div v-show="test" style="position:fixed;top:0;z-index:2001">
            <signature @closePop="closePop" @saveImg="complete"></signature>
        </div>
        </div>
      <page-none v-if="noData =='true'"  />
    </div>
</template>
<script type="text/ecmascript-6">
    import {
        getActivityInfoAndSigninRecordByStaff,
        getWXInfo,
        signinHonoreeSignature
    } from "@/common/api";
    import { toast } from "@/common/api/api.js";
    const wx = require("weixin-js-sdk");
    import QRCode from "qrcode";
    import signature from "../../components/signature.vue";
    import activityHeader from './component/activityHeader'
    import activityConfig from '../../centralControl/utils/activityConfig'
    import pageNone from "../../components/pageNone";
    var timer = "";
    export default {
        name: "directActivity", //直接参加的活动，不需要报名
        data() {
            return {
                jsApiTicket: "",
                list: [],
                radio: "",
                radio_local: "",
                centerDialogVisible: false,
                directActivityDetails: {},
                loadingFull: false,
                loading: false,
                test: false,
                state: 1,
                qrcodeImg: "",
                wxConfigData: {},
                currentBaseInfo: {},
                foldBtn: true,
                foldHeight: "160",
                fold: false,
                contentScollHeight: "",
                signature: "",
                roleCode: "",

                btnText: "领 奖 签 名",
                textList:[],
                textObj:{},
                myHtml:'',
                statusTextObj:{
                    '0':'当前活动暂未开始',
                    '2':'该活动已经结束'
                },
                noData: "" //页面接口返回错误标识
            };
        },
        components: {
            signature,
            activityHeader,
            pageNone
        },
        created() {
            if (sessionStorage.getItem("isdirectPage") != 1) {
                sessionStorage.setItem("isdirectPage", "1");
                let signGroupId = this.$route.query.signGroupId
                    ? this.$route.query.signGroupId
                    : "";
                // location.href = `${location.origin}/directActivity?id=${this.$route.query.id}&status=${this.$route.query.status}&signGroupId=${signGroupId}`;
                // location.assign = `${location.origin}/directActivity?id=${this.$route.query.id}&status=${this.$route.query.status}&signGroupId=${signGroupId}`;
            }
            // this.getDirectActivity(data, true);
        },
        mounted() {
            this.currentBaseInfo = JSON.parse(localStorage.getItem("loginInfo"));
            getWXInfo({
                localUrl: location.href,
                appId:localStorage.getItem("appId")
            }).then(res => {
                if (res.code == 200) {
                    let data = res.data;
                    this.wxConfigData = data;

                    wx.config({
                        appId: data.appId,
                        timestamp: data.timestamp, //new Date().getTime(),
                        nonceStr: data.nonceStr,
                        signature: data.signature,
                        jsApiList: ["wx-open-launch-weapp"],
                        openTagList:["wx-open-launch-weapp"]
                    });

                    // wx.config({
                    //     debug:true,
                    //     appId: data.appId,
                    //     timestamp: data.timestamp, //new Date().getTime(),
                    //     nonceStr: data.nonceStr,
                    //     signature: data.signature,
                    //     jsApiList: ["getLocation","wx-open-launch-weapp"],
                    //     openTagList:["wx-open-launch-weapp"]
                    // });

                    wx.ready((r) => {
                        this.myHtml=`<div style="display: flex;flex-direction: column;margin-left:20px;">
                      <svg t="1597737089731" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2966" width="28" height="28"><path d="M986.606857 548.505425 37.393143 548.505425c-20.156062 0-36.511565-16.35448-36.511565-36.505425 0-20.155039 16.355503-36.510542 36.511565-36.510542l949.213713 0c20.188808 0 36.511565 16.35448 36.511565 36.510542C1023.117398 532.149922 1006.794641 548.505425 986.606857 548.505425L986.606857 548.505425z" p-id="2967" fill="#49BFBA"></path><path d="M877.080348 986.610438 658.033469 986.610438c-20.188808 0-36.511565-16.320711-36.511565-36.510542 0-20.188808 16.321734-36.511565 36.511565-36.511565l219.047902 0c20.154016 0 36.510542-16.355503 36.510542-36.505425L913.591913 694.542476c0-20.188808 16.316617-36.511565 36.511565-36.511565 20.188808 0 36.505425 16.322757 36.505425 36.511565l0 182.542476C986.606857 937.465135 937.46667 986.610438 877.080348 986.610438L877.080348 986.610438z" p-id="2968" fill="#49BFBA"></path><path d="M329.453942 986.610438 146.911466 986.610438c-60.379159 0-109.519346-49.143257-109.519346-109.525486L37.39212 694.542476c0-20.188808 16.35448-36.511565 36.504402-36.511565 20.155039 0 36.510542 16.322757 36.510542 36.511565l0 182.542476c0 20.147876 16.389272 36.505425 36.504402 36.505425L329.453942 913.590378c20.155039 0 36.512588 16.322757 36.512588 36.511565C365.965507 970.289728 349.608981 986.610438 329.453942 986.610438L329.453942 986.610438z" p-id="2969" fill="#49BFBA"></path><path d="M73.896522 365.961926c-20.149922 0-36.504402-16.353456-36.504402-36.503379L37.39212 146.916071c0-60.386322 49.140187-109.526509 109.519346-109.526509L329.453942 37.389562c20.155039 0 36.512588 16.355503 36.512588 36.510542 0 20.147876-16.355503 36.504402-36.512588 36.504402L146.911466 110.404506c-20.11513 0-36.504402 16.393365-36.504402 36.510542l0 182.542476C110.408087 349.607446 94.051561 365.961926 73.896522 365.961926L73.896522 365.961926z" p-id="2970" fill="#49BFBA"></path><path d="M950.101431 365.961926c-20.192901 0-36.511565-16.353456-36.511565-36.503379L913.589866 146.916071c0-20.117177-16.35448-36.510542-36.510542-36.510542L658.033469 110.405529c-20.188808 0-36.511565-16.356526-36.511565-36.504402 0-20.155039 16.321734-36.510542 36.511565-36.510542l219.047902 0c60.386322 0 109.525486 49.140187 109.525486 109.526509l0 182.542476C986.606857 349.607446 970.289216 365.961926 950.101431 365.961926L950.101431 365.961926z" p-id="2971" fill="#49BFBA"></path></svg>
                      <div style="color:#29BEBC;font-size:14px;margin-top:10px">扫码O</div>
                    </div>`
                    })

                    this.getDirectActivity(data, true);
                    if (this.$route.query.status == 1) {
                        timer = setInterval(this.time, 10000);
                    }
                }
            });
        },

        destroyed() {
            clearInterval(timer);
            timer = null;
        },

        // beforeRouteEnter(to, from, next){
        //       const u = navigator.userAgent.toLowerCase();
        //   if (u.indexOf("like mac os x") < 0 || u.match(/MicroMessenger/i) != "micromessenger")return;
        //   if (to.path !== global.location.pathname) {
        //     location.assign(to.fullPath);
        //   }
        // },
        methods: {
            getPath(item){
                console.log(item)
                const {id,signGroupId} =  this.$route.query;
                let {currentBaseInfo} = this 
                let currentPath=`pages/scanner/scanner.html?staffId=${currentBaseInfo.id}&hospitalCode=${currentBaseInfo.hospitalCode}&unitCode=${currentBaseInfo.unitCode}&activityId=${id}&signGroupId=${signGroupId}&punchCardId=${item.punchCardId}&punchCardName=${item.punchCardName}&signType=bt`;
                return currentPath;
            },
            weappLaunch(e){
                console.log("weappLaunch",e);
            },
            weappError(e){
                console.log("weappError",e);
            },
            jumpToXcx(obj){
                // console.log("创建小程序QR");
                // let url = "http://wx.shx.logimis.com/mini?activityId="+this.$route.query.id
                //         +"&staffId="+this.currentBaseInfo.id
                //         +"&signGroupId="+this.$route.query.signGroupId || "";
                //
                // url = "http://wx.shx.logimis.com/mini?activityId=11&staffId=1&signGroupId=1&a=a";
                //
                // console.log(url);
                //
                // QRCode.toDataURL(url).then(r => {
                //   console.log("miniqr",r);
                //   let div1 = document.createElement("div");
                //   div1.style="position: fixed;top:0;left: 0;width:100vw;height: 100vh;background: rgba(0,0,0,.5);color:#fff;" +
                //           "    display: flex; " +
                //           "    justify-content: center; " +
                //           "    align-items: center; " +
                //           "    height: 100vh;flex-direction: column ";
                //   div1.innerHTML="<img src='"+r+"' style='width:300px;height: 300px'/><p>长按识别二维码打卡</p>";
                //   document.body.append(div1);
                // }).catch(e=>{console.error(e)});
            },
            qqMapTransBMap(lng, lat) {
                let x_pi = (3.14159265358979324 * 3000.0) / 180.0;
                let x = lng;
                let y = lat;
                let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
                let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
                let lngs = z * Math.cos(theta) + 0.0065;
                let lats = z * Math.sin(theta) + 0.006;
                return {
                    lng: lngs,
                    lat: lats
                };
            },
            time() {
                let punchCard = this.directActivityDetails.punchCard;
                if (punchCard) {
                    let punchCardLength = punchCard.filter(item => {
                        return item.punchTime == "未打";
                    });
                    if (punchCardLength.length > 0) {
                        this.getDirectActivity(this.wxConfigData);
                    } else {
                        clearInterval(this.time);
                    }
                }
                return "";
            },
            toggleFlod() {
                this.fold = !this.fold;
                let scrollHeight = this.$refs.fold.scrollHeight;
                if (this.fold == true) {
                    this.foldHeight=scrollHeight;
                } else {
                    this.foldHeight = "160";
                }
                this.getActivityInfo.content = str;
            },
            refreshQrcode() {
                wx.ready(() => {
                    wx.getLocation({
                        type: "gcj02",
                        success: res => {
                            let bmapCoord = this.qqMapTransBMap(res.longitude, res.latitude);
                            let clockInfo = {
                                lat: bmapCoord.lat || 0,
                                lng: bmapCoord.lng || 0,
                                time: new Date().getTime(),
                                staffId: this.currentBaseInfo.id,
                                signGroupId: this.$route.query.signGroupId || "" //'68cccd15d7814e69b2345301364d5ad7',
                            };
                            // this.createQrcode(JSON.stringify(clockInfo));
                            this.loading = false;
                        },
                        fail: res => {
                            //  alert("获取地理位置失败");
                        }
                    });
                });
                this.createQrcode(
                    JSON.stringify({
                        lat: "0",
                        lng: "0",
                        time: new Date().getTime(),
                        activityId: this.$route.query.id,
                        staffId: this.currentBaseInfo.id,
                        signGroupId: this.$route.query.signGroupId || ""
                    })
                );
            },
            createQrcode(option) {
                QRCode.toDataURL(option, {
                    width: 300,
                    height: 300
                })
                    .then(url => {
                        this.$nextTick(() => {
                            this.qrcodeImg = url;
                        });
                    })
                    .catch(err => {});
            },
            getDirectActivity(data, flag) {
                let _this = this;
                getActivityInfoAndSigninRecordByStaff({
                    activityId: this.$route.query.id,
                    staffId: this.currentBaseInfo.id,
                    signGroupId: this.$route.query.signGroupId || ""
                }).then(res => {
                    if (res.code == 200) {
                        this.noData = "false";
                        res.data.content = res.data.content
                            .replace(new RegExp("&lt;", "g"), "<")
                            .replace(new RegExp("&gt;", "g"), ">")
                            .replace(new RegExp("&quot;", "g"), "");

                        // 处理展开与收起的逻辑
                        // this.$nextTick(()=>{
                        //   let actualheight = this.$refs.fold.offsetHeight;
                        //   let scrollHeight = this.$refs.fold.scrollHeight;
                        //   this.contentScollHeight = scrollHeight;
                        //   if (scrollHeight <= actualheight) {
                        //     this.foldBtn = false;
                        //   }
                        // })

                        // 新的活动头部
                        let {startTime,endTime,creatorOfficeLevel,location,punchCard,name,content,status,signGroup}=res.data;
                        // 起止时间
                        startTime=startTime&&startTime.split(" ")&&startTime.split(" ")[0];
                        endTime=endTime&&endTime.split(" ")&&endTime.split(" ")[0];
                        let during=startTime+' 至 '+endTime;
                        // 主办单位
                        let levelObj={
                            1:'工会',
                            2:'分会'
                        }
                        // 头部信息
                        _this.textList=[
                            {label:'主办单位',value:levelObj[creatorOfficeLevel]},
                            {label:'活动时间',value:during},
                            {label:'活动类型',value:'打卡活动',color:'#29BEBC'},
                            {label:'活动地点',value:location},
                            {label:'打卡次数',value:punchCard},
                        ]

                        if(signGroup&&signGroup.length)_this.textList.push({label:'活动形式',value:signGroup})
                        _this.textObj={
                            title:name,
                            statusName:activityConfig.statueObj[status],
                            status:status,
                            content:content
                        }
                        // 新的活动头部
                        _this.directActivityDetails = res.data;
                        _this.jsApiTicket = res.data.jsApiTicket;
                        localStorage.setItem('jsApiTicket',res.data.jsApiTicket);
                        let arr = res.data.punchCard&&res.data.punchCard.length&&res.data.punchCard.filter(item => {
                            //item.bottem = false; //临时改动
                            // item.bottem = true;
                            return item.punchTime == "未打";
                        });
                        if (res.data.signature) {
                            _this.btnText = "重 新 签 名";
                            if ((_this.btnText = "重 新 签 名")) {
                                _this.state = 1;
                            } else {
                                _this.state = 0;
                            }
                        } else {
                            if (arr.length > 0) {
                                _this.state = 0;
                            } else {
                                _this.state = 1;
                            }
                        }
                        _this.loadingFull = false;

                        wx.ready(() => {
                            wx.getLocation({
                                type: "gcj02",
                                success: res => {
                                    let bmapCoord = this.qqMapTransBMap(
                                        res.longitude,
                                        res.latitude
                                    );
                                    let clockInfo = {
                                        lat: bmapCoord.lat || 0,
                                        lng: bmapCoord.lng || 0,
                                        time: new Date().getTime(),
                                        staffId: this.currentBaseInfo.id,
                                        signGroupId: this.$route.query.signGroupId || ""
                                    };
                                    // this.createQrcode(JSON.stringify(clockInfo));
                                    this.loading = false;
                                },
                                fail: res => {
                                    // alert("获取地理位置失败");
                                }
                            });
                        });
                        this.createQrcode(
                            JSON.stringify({
                                lat: "0",
                                lng: "0",
                                time: new Date().getTime(),
                                activityId: this.$route.query.id,
                                staffId: this.currentBaseInfo.id,
                                signGroupId: this.$route.query.signGroupId || ""
                            })
                        );
                    } else {
                        this.noData = "true";
                        toast(this, res.message, "error");
                    }
                    this.loading = false;
                });
            },
            showPopup() {
                if (this.state == 1) {
                    this.test = !this.test;
                }
            },
            closePop() {
                this.test = false;
                //   this.$refs.myPopup.hide();
            },
            complete(data) {
                if (data) {
                    this.loading = true;
                    signinHonoreeSignature({
                        activityId: this.$route.query.id ? this.$route.query.id : "",
                        staffId: this.currentBaseInfo.id,
                        signinRecordId: this.directActivityDetails.signinRecordId,
                        signatureFile: data
                    }).then(res => {
                        if (res.code == 200) {
                            this.loading = false;
                            this.test = false;
                            this.getDirectActivity(this.wxConfigData);
                        } else {
                            this.loading = false;
                            // toast(this, res.message, "error");
                        }
                    });
                } else {
                    toast(this, "请完成签名后领取", "error");
                }
            },
            clockIn(item) {}
        },
        beforeRouteLeave(to, from, next) {
            sessionStorage.setItem("isdirectPage", "0");
            // if (to.name === "activity") {
            //   next({ name: "home", query: { label: "工会活动" } });
            // } else {
            next();
            // }
        }
    };
</script>
<style lang="stylus" type="stylesheet/stylus">
    @import '../../assets/stylus/detail.styl';
    @import '../../assets/stylus/mixin.styl';

    .direct-content {
    .my_html {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
    .el-radio-group {
        display: block;
    }

    .ibeacon-btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background: rgba(56, 199, 196, 1) !important;
        color: #fff !important;
    }

    .ibeacon-info {
    .searchBtn {
        background: rgba(56, 199, 196, 1) !important;
        color: #fff !important;
        margin: 5px;
    }

    .tip {
        font-size: 12px;
        margin-bottom: 10px;
    }

    .el-dialog {
        width: 80%;

    .el-dialog__header {
        background: rgba(56, 199, 196, 1) !important;

    .el-dialog__title {
        color: #fff !important;
    }
    }

    .el-dialog__body {
        max-height: 280px;
        overflow: scroll;
    }

    .el-dialog__footer {
        border-top: 1px solid #DCDFE6;

    .complete {
        background: rgba(56, 199, 196, 1);
        color: #fff;
    }
    }

    .radio-info {
    .title {
        font-size: 16px;
        padding: 8px;
    }

    .el-radio__input.is-checked+.el-radio__label {
        color: rgba(56, 199, 196, 1) !important;
    }

    .el-radio__input.is-checked .el-radio__inner {
        border-color: rgba(56, 199, 196, 1);
        background: rgba(56, 199, 196, 1);
    }

    .el-radio {
        padding: 5px 0;
    }
    }
    }
    }
    }

    .container {
        overflow-y: scroll;
        overflow-x: hidden;
    // margin-bottom: 105px;
    // height: calc(100vh - 105px);
        background:#fff;
    }

    .sign-footer {
        position: absolute;
    // bottom: 0;
        margin: 0 !important;
        width: 100%;
        background:#fff;
    .sign {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        margin: 10px 15px 15px 15px;

    .sign-input {
        flex: 4;
        height: 80px;
        margin-right: 20px;
        background: rgba(243, 245, 248, 1);
        border-radius: 10px;
        position: relative;

    .img {
        width: 154px;
        height: 53px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    }

    .save-btn, .save-btn-disabled {
        flex: 1;
        height: 80px;
        border-radius: 10px;
        font-size: 20px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        margin: 0;

    p {
        height: calc(100% - 10px);
        width: 50px;
        text-align: center;
        padding: 0px 20px;
        line-height: 30px;
        margin-top: 10px;
    }
    }

    .save-btn-disabled {
        background: rgba(229, 229, 229, 1);
    }

    .save-btn {
        background: linear-gradient(0deg, rgba(61, 212, 243, 1), rgba(12, 212, 183, 1));
    }
    }
    }

    .direct-container {
        width: 100%;
        position: relative;
        height: 100vh;

    .direct-header {
        padding: 0.5rem;
        border: 1px solid #E5E5E5;

    .header-title {
        height: 40px;
        font-size: 18px;
        font-weight: 500;
        color: rgba(53, 53, 53, 1);
    }

    .header-date {
        height: 20px;
        line-height: 20px;

    .hint {
        font-size: 14px;
        padding: 0.03rem 0.2rem;
        background: rgba(233, 244, 244, 1);
        font-weight: bold;
        height: 18px;
        line-height: 18px;
        color: rgba(56, 199, 196, 1);
    }

    .date {
        font-size: 14px;
        font-weight: 500;
        color: rgba(172, 172, 183, 1);
        margin-left: 0.5rem;
    }
    }
    }

    .direct-content {
        padding: 0.12rem 0.5rem;
        background: #fff;
        // margin-top: 0.5rem;
        color: #888888;
        margin-bottom: 10px;

    .content-text {
        margin-bottom: 0.5rem;
        font-size: 16px;
        line-height: 2;
    }

    img {
        max-width: 100%;
    }

    .content-qrcode {
        // margin-top: 0.5rem;
        color: rgba(172, 172, 183, 1);
        font-size: 14px;
        text-align: center;

    .refresh {
        font-size: 14px;
        font-weight: 500;
        color: rgba(56, 199, 196, 1);
        margin-top: 0.36rem;
    }
    }

    .content-clockin {
        margin-top: 0.5rem;

    .clock {
        margin-top: 0.3rem;

    .clock-list {
        display: flex;
        height: 70px;
    flex-dire
    .list-hint {
        flex: 1;
        line-height: 65px;

    span {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
    }
    }

    .unrecord {
        background: rgba(243, 245, 248, 1);
        color: #8496B0;
    }

    .record {
        background: rgba(56, 199, 196, 1);
        color: rgba(255, 255, 255, 1);
    }

    .list-record {
        flex: 11;
        height: 100%;
        padding-left: 0.36rem;
        border-radius: 8px;
        position: relative;

    .date {
        height: 50px;
        line-height: 50px;
        font-size: 23px;
        font-weight: 400;
    }

    .position {
        font-size: 14px;
        font-weight: 300;
    }
    }
    }
    }
    }
    }
    }

    .direct-footer {
        margin: 0.5rem 0;
    }

    .sino-welfare-footer {
        width: 100%;
        text-align: center;
        max-height: 300px;

    .save-btn {
        width: 190px;
        height: 61px;
        line-height: 61px;
        display: inline-block;
        text-align: center;
        background: linear-gradient(0deg, rgba(61, 212, 243, 1), rgba(12, 212, 183, 1));
        border-radius: 52px;
        font-size: 20px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
    }

    .save-btn-disabled {
        width: 190px;
        height: 61px;
        line-height: 61px;
        display: inline-block;
        text-align: center;
        background: linear-gradient(0deg, rgba(61, 212, 243, 0.5), rgba(12, 212, 183, 0.5));
        border-radius: 52px;
        font-size: 20px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
    }

    }
    .punch_text {
        margin-left:10px;
        div{
            color:#29BEBC;
            opacity:0.34;
            font-size:14px;
            margin-top:10px;
        }
        svg {
            opacity:0.34;
        }
    }
</style>